import { withSafeSuspense } from '@calendly/safe-suspense'
import { lazy } from 'react'
import { Route, Switch } from 'react-router-dom'

const OutlookDesktopConnect = withSafeSuspense(
  lazy(async () => ({ default: (await import('./connect')).OutlookDesktopConnect }))
)
const OutlookDesktopCreation = withSafeSuspense(
  lazy(async () => ({ default: (await import('./create')).OutlookDesktopCreation }))
)
const OutlookDesktopView = withSafeSuspense(
  lazy(async () => ({ default: (await import('./view')).OutlookDesktopView }))
)

const OutlookDesktopConnectSuccess = withSafeSuspense(
  lazy(async () => ({ default: (await import('./success')).OutlookDesktopConnectSuccess }))
)
export const OutlookDesktopRoutes = ({ match }) => (
  <Switch>
    <Route path={`${match.url}`} exact component={OutlookDesktopView} />
    <Route path={`${match.url}/new`} exact component={OutlookDesktopCreation} />
    <Route path={`${match.url}/:id/edit`} component={OutlookDesktopConnect} />
    <Route path={`${match.url}/:id/success`} component={OutlookDesktopConnectSuccess} />
  </Switch>
)
